import React, { memo } from 'react'

const Header = memo(() => {
  return (
    <>
          <div className="waves-container">
    <img
      src="img/Graphic-Purple-Wave.svg"
      loading="lazy"
      alt=""
      className="purple-wave"
    />
    <img
      src="img/Graphic-Blue-Wave.svg"
      loading="lazy"
      alt=""
      className="blue-wave"
    />
    <img
      src="img/Graphic-Teal-Wave.svg"
      loading="lazy"
      alt=""
      className="teal-wave"
    />
  </div>
  <nav className="navbar navbar-expand-lg nav_fix">
    <div className="container">
      <a className="navbar-brand" href="/"> 
        <img src="img/logo.png" alt="Logo" />
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapsibleNavbar"
      >
        <i className="bi bi-list"></i>
      </button>
      <div className="collapse navbar-collapse " id="collapsibleNavbar">
        <ul className="navbar-nav ms-md-auto me-md-4">
          <li className="nav-item">
            <a className="nav-link active" href="/"> 
              Home
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">
              Speakers
            </a>
          </li>
          <li className="nav-item">
          <a className="nav-link" href="/sponsors">
              Sponsors
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">
              {" "}
              Partners
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">
              Floor plan{" "}
            </a>
          </li>
          <li className="nav-item ms-lg-4">
            <a href="#" className="btn  transparent-btn  ">
              Become Sponsor
            </a>
          </li>
          <li className="nav-item ms-lg-4">
            <a href="#" className="btn  ">
              Buy Tickets
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
    </>
  )
})

export default Header